import { useSelector } from "react-redux";
import { RootState } from '../../redux/store';
import { useEffect, useState } from 'react';
import { getBreakTheIceQuestion } from '../../services/questionService';
import { FiRefreshCcw } from "react-icons/fi";
import { useHistory } from 'react-router-dom';


export type BreakTheIceQuestionProp = {
    buttonText: string | undefined;
    questionId: number;
    questionSubTitle: string | undefined;
    question: string;
    skipButtonLink: string | undefined;
}

const BreakTheIceQuestion = ({ handleNext, messageId, questionTitle, questionId }: any) => {
    const history = useHistory();
    const member = useSelector((state: RootState) => state.member);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [question, setQuestion] = useState<BreakTheIceQuestionProp>();
    const [questionAnswer, setQuestionAnswer] = useState<string>("");
    const [errors, setErrors] = useState<any>({});


    useEffect(() => {
        getQuestion();
    }, [])


    const validateForm = () => {
        let isvalid = true;
        let errors: any = {};
        if (questionAnswer === "") {
            errors["questionAnswer"] = "חובה להזין תשובה";
            isvalid = false;
        }
        setErrors(errors);
        return isvalid;
    };

    const getQuestion = async () => {

        let retriveQuesionId = false;
        let id = null;
        if (question) id = question.questionId;
        if (messageId) {
            retriveQuesionId = true;
            id = questionId;
        }
        const { data }: any = await getBreakTheIceQuestion(member.memberCode, id, retriveQuesionId);
        setQuestion(data);

    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (validateForm()) {
            let data = {
                text: questionAnswer,
                memberCode: member.memberCode,
                question: question?.question,
                questionId: question?.questionId,
                messageId
            }
            history.goBack();
            handleNext(data);
        }
    };

    const enabled =
        questionAnswer.length > 0;


    return (
        <>
            <div className="content_sec red wf-section">
                <div className="mood_info_content">
                    <a onClick={() => history.goBack()} href="#" className="mood_close w-inline-block">
                        <img src="/assets/images/ic_back.svg" loading="lazy" alt="" />
                    </a>
                    <div className="mood_info_pict">
                        <img src="/assets/images/mood_ic_10.png" loading="lazy" alt="" />
                    </div>
                    <div className="mood_info_txt">שאלה בשביל לשבור את הקרח</div>
                    <h2 className="signup_title mood">{question?.question}</h2>

                    <div className="mood_form_block w-form">
                        {
                            messageId ? null : <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                padding: 5,
                                cursor: "pointer"
                            }}
                                onClick={getQuestion}>
                                <span style={{ marginLeft: 5, textDecoration: "underline" }}>החלפת שאלה</span> <FiRefreshCcw />
                            </div>
                        }

                        <form onSubmit={handleSubmit}>
                            <textarea
                                placeholder="והתשובה שלך לשאלה הזו היא..."
                                maxLength={5000}
                                value={questionAnswer} onChange={(e) => {
                                    setErrors({})
                                    setQuestionAnswer(e.target.value)
                                }
                                }
                                className="txt_field mood_area w-input"
                                style={{ textAlign: 'right' }}
                            />
                            <div className="form_allert" style={{ display: errors && errors["questionAnswer"] ? "contents" : "block" }}>{errors["questionAnswer"]}</div>

                            <input autoComplete="off"
                                disabled={!enabled}
                                type="submit"
                                value="שליחה"
                                data-wait
                                className={enabled ? "button_full mood w-button" : "button_full send w-button"}
                            />
                        </form>
                    </div>
                </div>
            </div>

        </>
    )

}


export default BreakTheIceQuestion;


